/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type { DmpDocumentContent } from "parog-web/cnam/types";
import { DocumentVisibility } from "parog-web/cnam/types";
import type DmpDocumentMetadata from "parog-web/models/dmp-document-metadata";
import emberSwal from "ui-kit/utils/ember-swal";

interface Args {
  metadata: DmpDocumentMetadata;
  content: DmpDocumentContent;
  isRunning: boolean;
  returnToDocuments: () => Promise<void>;
}

export default class DocumentsRetrieveAccessFormShowContentComponent extends Component<Args> {
  @tracked shouldShowVisibilityAlert = true;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    if (
      (this.hiddenToPatient || this.hiddenToLegalRepresentatives) &&
      this.shouldShowVisibilityAlert
    ) {
      const title = `Vous allez consulter un document ${
        this.hiddenToPatient
          ? "non visible par le patient"
          : "non visible par les représentants légaux"
      }`;
      emberSwal
        .fire({
          title,
          text: "Êtes-vous sûr de vouloir le consulter ?",
          icon: "warning",
          cancelButtonText: "Consulter",
          showCancelButton: true,
          confirmButtonText: "Revenir à la liste de documents",
          confirmButtonColor: "#d33"
        })
        .then(result => {
          if (result.isConfirmed) {
            this.args.returnToDocuments();
          } else {
            this.shouldShowVisibilityAlert = false;
          }
        });
    } else {
      this.shouldShowVisibilityAlert = false;
    }
  }

  get isRunning(): boolean {
    return this.args.isRunning || this.shouldShowVisibilityAlert;
  }

  get hiddenToPatient(): boolean {
    return this.args.metadata?.confidentialities.includes(
      DocumentVisibility.HIDDEN_TO_PATIENT
    );
  }

  get hiddenToLegalRepresentatives(): boolean {
    return this.args.metadata?.confidentialities.includes(
      DocumentVisibility.HIDDEN_TO_LEGAL_REPRESENTATIVES
    );
  }

  get addedByPatient(): boolean {
    return this.args.metadata?.classCode == "90";
  }
}
